<template>
    <nav class="sidebar-nav">
        <MySidebarChildren class="nav" :nav-items.sync="navItemsComputed"></MySidebarChildren>
    </nav>
</template>
<script>
import MySidebarChildren from './MySidebarChildren.vue';
export default {
    name: 'sidebar-nav',
    components: {
        MySidebarChildren
    },
    props: {
        navItems: {
            type: Array,
            required: true
        }

    },
    computed: {
        currentRoutePath: {
            get() {
                let currRoute = this.$route;
                return currRoute.fullPath;
            }
        },
        navItemsComputed: {
            get() {
                var currNavItems = this.navItems;
                currNavItems.forEach(navItm => {
                    if(this.currentRoutePath.includes(navItm.url)) {
                        navItm.isOpen = true;
                    }
                    else {
                        navItm.isOpen = false;
                    }
                    if(navItm.children && navItm.children.length) {
                        navItm.children.forEach(child => {
                            if(this.currentRoutePath.includes(child.url)) {
                                child.isOpen = true;
                                navItm.isOpen = true;
                            }
                        });
                    }
                });
                return currNavItems;
            }
        },
    }
}
</script>